import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Panel, Form, Message } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ProposalReviseForm from '../../components/forms/proposalReviseForm/ProposalReviseForm'
import { saveReviewerFeedback } from '../../redux/actions/reviewerFeedback'
import pathname from '../../constants/pathname'
import { useParams, useHistory } from 'react-router-dom'
import { startLoading, doneLoading } from '../../utils/loading'

export default function ReviewerSendBack(props) {
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isLoading, setIsLoading] = useState()
  const [isError, setIsError] = useState()
  // const { projectId } = useParams()
  const projectId = sessionStorage.getItem('projectId')
  let history = useHistory()

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      const response = await saveReviewerFeedback(projectId, request)

      console.log('response', JSON.stringify(response))
      setIsLoading(false)
      doneLoading()
      return history.push(`${pathname.proposal.overview.overviewCoworker}`)
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('ReviewerSendBack onSubmit', data)

    let request = []
    data.requestBody?.forEach((revise) => {
      revise.subItems.forEach((subRevise) => {
        if (subRevise.subItems && subRevise.subItems.length > 0) {
          subRevise.subItems.forEach((item) => {
            request.push(item)
            // }
          })
        } else {
          request.push(subRevise)
        }
      })
    })

    console.log('request', JSON.stringify(request))
    handleCallService(request)
  }

  return (
    <>
      <Form fluid>
        <Panel shaded header="" bordered collapsible defaultExpanded>
          <ProposalReviseForm
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
          <hr />
          {isError && (
            <div style={{ marginTop: 10, marginBottom: 10 }}>
              <Message showIcon type="error" description={`ส่งกลับผู้ขอรับทุนไม่สำเร็จ`} />
            </div>
          )}

          <SaveButton disabled={isLoading} onClick={handleSubmit(onSubmit)}>
            ส่งกลับผู้ขอรับทุน
          </SaveButton>
        </Panel>
        <br />
      </Form>
    </>
  )
}
